<template>
  <nav class="menu-bar" v-if="authStore.isAuth">
    <ul class="left">
      <li class="item" @click="$router.push({ name: RouterConst.SHINSEI_MENU })">
        <div>
          <i class="fa-solid fa-inbox"></i>
          <span>申請の<br>管理</span>
        </div>
      </li>
      <li class="item" @click="$router.push({ name: RouterConst.KINMU_LIST })"  v-if="Config.APP_MODE === APP_MODE.KINTAI && authStore.hasPermission(PermissionConst.GET_DAKOKU)">
        <div>
          <i class="fa-solid fa-table-list"></i>
          <span>タイム<br>シート</span>
        </div>
      </li>
    </ul>

    <div class="home">
      <router-link :to="{ name: RouterConst.HOME }">ホーム<br>(打刻)</router-link>
    </div>

    <ul class="right">
      <li class="item" @click="$router.push({ name: RouterConst.OSHIRASE_LIST })">
        <div>
          <i class="fa-solid fa-bullhorn"></i>
          <span>お知らせ<br>一覧</span>
        </div>
      </li>
      <li class="item" @click="menuStore.panelOpen()">
        <div>
          <i class="fa-solid fa-ellipsis"></i>
          <span>メニュー</span>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMenuStore } from '@/store/menu'
import { useAuthStore } from '@/store/auth'
import { RouterConst } from '@/const/Router'
import Config from '@/const/Config'
import { APP_MODE } from '@/const/Constants'
import { PermissionConst } from '@/const/Permission'

export default defineComponent({
  setup() {
    const menuStore = useMenuStore()
    const authStore = useAuthStore()

    return {
      Config,
      APP_MODE,
      PermissionConst,
      menuStore,
      authStore,
      RouterConst
    }
  },
  components: {
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/menu-bar.scss';
</style>
